<p-dialog [draggable]="false" [modal]="true" [style]="{ width: '40rem' }" [visible]="visible()" (visibleChange)="handleModalClose()">
    <ng-template #header>
        <div class="inline-flex items-center justify-center gap-2">
            <h4 class="text-xl font-semibold text-gray-800"> {{ "chipRegistration.signature.modalTitle" | translate}} </h4>
        </div>
    </ng-template>
    <p-stepper class="basis-[50rem] pointer-events-none" [value]="currentStep">
        <p-step-list>
            <p-step [value]="1">Veterinarian</p-step>
            <p-step [value]="2">Owner</p-step>
            @if (signatures().length === 3) {
                <p-step [value]="3">Previouse owner</p-step>
            }
        </p-step-list>
    </p-stepper>

    @if (showAlert()) {
        <div class="my-3">
            <app-alert
                [alertType]="'error'"
                [message]="'chipRegistration.signature.alertMessage' | translate"
                [title]="'chipRegistration.signature.alertTitle' | translate" />
        </div>
    }

    <canvas #canvas class="signature-canvas rounded-xl mb-3"></canvas>

    <div class="flex flex-row justify-between">
        <p-button class="cursor-pointer" severity="secondary" size="large" type="button" [disabled]="currentStep === 1 || signaturePad?.isEmpty()" [outlined]="true" (click)="prevStep()">
             <svg class="size-5" fill="currentColor" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                <path clip-rule="evenodd" d="M14 8a.75.75 0 0 1-.75.75H4.56l3.22 3.22a.75.75 0 1 1-1.06 1.06l-4.5-4.5a.75.75 0 0 1 0-1.06l4.5-4.5a.75.75 0 0 1 1.06 1.06L4.56 7.25h8.69A.75.75 0 0 1 14 8Z" fill-rule="evenodd" />
            </svg>
        </p-button>
        <p-button class="cursor-pointer" severity="secondary" size="large" type="button" [disabled]="currentStep === signatures().length || signaturePad?.isEmpty()" [outlined]="true" (click)="nextStep()">
             <svg class="size-5" fill="currentColor" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                <path clip-rule="evenodd" d="M2 8a.75.75 0 0 1 .75-.75h8.69L8.22 4.03a.75.75 0 0 1 1.06-1.06l4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5a.75.75 0 0 1-1.06-1.06l3.22-3.22H2.75A.75.75 0 0 1 2 8Z" fill-rule="evenodd" />
            </svg>
        </p-button>
    </div>

    <ng-template #footer>
        <div class="flex flex-row items-center gap-3 px-2 mt-6 justify-between w-full">
                <p-button label="Cancel" severity="contrast" (click)="handleModalClose()" />
            <div>
                <p-button class="mr-4" severity="secondary" [label]="'common.clear' | translate" (click)="clear()" />
                <p-button label="Save" severity="primary" (click)="save()" />
            </div>
        </div>
    </ng-template>
</p-dialog>
